import { render, staticRenderFns } from "./inventoryMovements.vue?vue&type=template&id=12361136&"
import script from "./inventoryMovements.vue?vue&type=script&lang=js&"
export * from "./inventoryMovements.vue?vue&type=script&lang=js&"
import style0 from "./inventoryMovements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports